import logoSrc from '@/assets/logo.png';
import './product-chrome.css';

interface ProductHeaderProps {
  product: 'assess';
}

export function ProductHeader({ product: _product }: ProductHeaderProps) {
  return (
    <header className="product-header">
      <div className="product-header__inner">
        <a href="https://www.paazio.com" className="product-header__logo-link">
          <img src={logoSrc} alt="Paazio" className="product-header__logo-img" />
        </a>
        <span className="product-header__badge">Assess</span>
        <nav className="product-header__nav">
          <a
            href="/tuition/login"
            className="product-header__switch-link"
          >
            Try Paazio Tuition →
          </a>
        </nav>
      </div>
    </header>
  );
}
